import { Filmomtale } from '@filmweb/sanity-types';
import { PortableTextBlock } from '@sanity/types';
import SMaxWidthContainer from 'components/framework/SMaxWidthContainer';
import RichText from 'components/richtext/RichText';
import { IMovieArticle } from 'lib/types/sanity';
import styled from 'styled-components';

//#region [Props]
const SMWContainer = styled(SMaxWidthContainer)`
	&:empty {
		display: none;;
	}
`
//#endregion

//#region [Props]
type OverriddenRichTextProps = {
	document?: IMovieArticle | null;
	filmomtale?: Filmomtale | null;
	field: "ingress" | "bodyText";
	className?: string;
};
//#endregion

//#region [Component]
export default function OverriddenRichText({ filmomtale, document, field, className }: OverriddenRichTextProps) {
	let fieldValue: PortableTextBlock[] | undefined = document?.[field];
	if ((fieldValue?.length ?? 0) === 0) {
		fieldValue = filmomtale?.[field] as (PortableTextBlock[] | undefined);
	}

	if ((fieldValue?.length ?? 0) === 0) {
		return null;
	}
	return <SMWContainer $forContent><RichText value={fieldValue} className={className} /></SMWContainer>
}
//#endregion